import axios from 'axios';
import { ImageServices } from "../../services/image.services";

const defaultState = {
  searchFilter: {
    keywords: [],
    mediaIds: [],
    type: null,
    from: null,
    to: null
  },

  foundJournals: [],

  pagination: {
    searchAfter: [],
    numOfJournals: 5
  },

  searchStats: {
    pages: '-',
    journals: '-',
    medias: '-'
  }, 

  mentionChartData: [],

  mentionChartInterval: 0
};

export default {
  namespaced: true,

  state: {
    searchFilter: {
      keywords: [],
      mediaIds: [],
      type: null,
      from: null,
      to: null
    },

    foundJournals: [],

    pagination: {
      searchAfter: [],
      numOfJournals: 5
    },

    searchLoading: true,

    searchStats: {
      pages: '-',
      journals: '-',
      medias: '-'
    }, 

    mentionChartData: [],

    mentionChartInterval: 0,

    mediaBasedCountData: []
  },

  mutations: {
    setSearchFilter(state, data) {
      state.searchFilter = data;
    },

    setFoundJournals(state, data) {
      state.foundJournals = data;
    },

    setPagination(state, data) {
      state.pagination = data;
    },

    setSearchLoading(state, data) {
      state.searchLoading = data
    },

    setSearchStats(state, data) {
      state.searchStats = data;
    },

    setMentionChartData(state, data) {
      state.mentionChartData = data;
    },

    setMentionChartInterval(state, data) {
      state.mentionChartInterval = data;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    },

    setMediaBasedCountData(state, data) {
      state.mediaBasedCountData = data;
    }
  },

  actions: {
    searchJournals({ commit, state, dispatch }) {
      commit('setSearchLoading', true);

      const payload = {
        filter: state.searchFilter,
        pagination: state.pagination
      };

      return axios.post(
        `${process.env.VUE_APP_API_URL}search/list`,
        payload
      )
      .then(({ data }) => {
        commit('setSearchLoading', false);

        let { foundJournals, searchAfter } = data;

        const oldJournals = [...state.foundJournals];

        if (foundJournals) {
          for (let journal of foundJournals) {
            oldJournals.push(journal);
          }
          commit('setFoundJournals', oldJournals);
        }

        searchAfter = searchAfter || [];
        commit('setPagination', Object.assign({}, 
          state.pagination, { searchAfter }));
      })
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    deleteJournal({ commit, state }, id) {
      return axios.delete(process.env.VUE_APP_API_URL + `journals/${id}`)
      .then(() => {
        const unremoved = state.foundJournals
          .filter(journal => journal.id !== id);
        commit('setFoundJournals', unremoved);
      });
    },

    resetSearch({ commit, state }) {
      commit('setFoundJournals', []);
      commit('setPagination', Object.assign({}, 
        state.pagination, { searchAfter: [] }));
      commit('setSearchStats', {
        pages: '-',
        journals: '-',
        medias: '-'
      });
    },

    getSearchStats({ commit, state, dispatch }) {
      return axios.post(
        `${process.env.VUE_APP_API_URL}search/stats`,
        state.searchFilter
      )
      .then(({ data }) => commit('setSearchStats', data))
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    getMentionChartData({ commit, state, dispatch }) {
      return axios.post(
        process.env.VUE_APP_API_URL + 'search/mention_histogram',
        state.searchFilter
      )
      .then(({ data })=> {
        commit('setMentionChartData', data.values);
        commit('setMentionChartInterval', data.interval);
      })
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    getMediaBasedCountData({ commit, state, dispatch }) {
      return axios.post(
        process.env.VUE_APP_API_URL + 'search/counts_on_media',
        state.searchFilter
      )
      .then(async ({ data }) => {
        const modData = [];
        for (let d of data) {
          const a = Object.assign({}, d);
          a.media.logoImg = await ImageServices.loadImage(d.media.logoLink);
          modData.push(a);
        }
        commit("setMediaBasedCountData", modData);
      })
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    }
  }
};